module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/nyuskousen0007#rpt01"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_vm._v("THE STRUCTURE OF PRODUCTION: A HISTORICAL SURVEY")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "eps"
  }, [_vm._v("A study of the history of opinion is a necessary preliminary to the emancipation of the mind.—Lord Keynes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0755b1ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nyu-skousen-0012.vue
// module id = 87
// module chunks = 0